import React from 'react';
import moment from 'moment';
import { Form } from 'antd';
import TemplateInfo from './FormSections/TemplateInfo';
// import MonetizationTemplate from './MonetizationTemplate';
import Monetization from '../../../Executorship/common/FormSections/Monetization';
import Vehicle from '../../../Executorship/common/FormSections/Vehicle';
import PaymentDeadlineInDays from '../../../Executorship/common/FormSections/PaymentDeadlineInDays';

class TemplateCardInfo extends React.Component {
  render() {
    const { form, isEditable, validateField } = this.props;
    return (
      <div className="template-content card-info">
        <Form layout="inline">
          <div>
            <TemplateInfo
              form={form}
              disabled={!isEditable}
              validateField={validateField}
            />
          </div>
          <div className="template-content__vehicle">
            <Vehicle form={form} disabled={!isEditable} />
          </div>
          <div>
            <Monetization form={form} disabled={!isEditable} />
          </div>
          <div>
            <PaymentDeadlineInDays form={form} disabled={!isEditable} />
          </div>
        </Form>
      </div>
    );
  }
}

class TemplateInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      default: {},
    };
    this.defaultProfileData = {};
    this.flagInitEditing = false;
  }
  componentDidMount() {
    this.initEditing();
  }
  componentDidUpdate(prevProps, prevState) {
    this.initEditing();
    //if (this.props.checkFormErrors) {
    //  this.props.checkFormErrors(this.props.name);
    //}
  }
  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  //
  initEditing = () => {
    let { isEditable, data: dataProps, templateId } = this.props;
    if (
      !this.flagInitEditing &&
      isEditable &&
      ((dataProps && templateId > 0) || templateId === 0)
    ) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps && templateId !== 0) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item],
          };
        });
      }
      // add default value
      Object.keys(this.state.default).forEach(item => {
        if (!newEditData[item]) {
          newEditData[item] = this.state.default[item]
            ? { value: this.state.default[item] }
            : {};
        }
      });
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        if (this.formRef) {
          this.formRef.validateFields((errors, values) => {
            this.changeValues(values);
          });
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };

  handleFieldsChange = values => {
    this.setState(
      state => ({
        data: {
          ...state.data,
          ...values,
        },
      }),
      () => {
        this.changeValues(values);
      }
    );
  };

  validateField = nameField => {
    let result =
      this.formRef &&
      this.formRef.isFieldTouched(nameField) &&
      this.formRef.getFieldError(nameField);
    // todo Проверить есть ли в сторе ошибки от сервера
    //let err = 'Уже есть такой пользователь';
    //if(nameField === 'phone')
    return {
      status: result ? 'error' : '',
      help: result || '',
    };
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  //
  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    return (
      <FormTemplateCard
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
        validateField={this.validateField}
      />
    );
  }
}

const FormTemplateCard = Form.create({
  name: 'formTemplateCard',
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    // console.log('mapPropsToFields',props);
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }

        let all = true;
        // Маршрут
        if (name === 'routes') {
          let routes = props.isEditable
            ? props.data[name].value
            : props.data[name];
          routes &&
            routes.forEach((item, index) => {
              obj['route' + index] = Form.createFormField({
                value: props.isEditable
                  ? item.value
                    ? item.value
                    : item.route
                  : item.route,
              });
              obj['routeDuration' + index] = Form.createFormField({
                value: props.isEditable
                  ? item.duration
                  : moment(item.duration, 'HH:mm'),
              });
            });
        }
        // Монетизация
        if (name === 'monetization' && props.data[name]) {
          all = false;
          const {
            name: monetizationName = null,
            template: monetizationTemplate = null,
          } = props.data[name];
          obj[name + '.name'] = Form.createFormField({
            value: props.isEditable
              ? monetizationName && monetizationName.value
              : monetizationName,
          });
          if (monetizationTemplate) {
            Object.keys(monetizationTemplate).forEach(key => {
              let keyName = name + '.template.' + key;
              if (
                monetizationTemplate[key] &&
                monetizationTemplate[key].constructor === Object
              ) {
                Object.keys(monetizationTemplate[key]).forEach(key2 => {
                  obj[keyName + '.' + key2] = Form.createFormField({
                    value: props.isEditable
                      ? monetizationTemplate[key][key2].value
                      : monetizationTemplate[key][key2],
                  });
                });
              } else {
                obj[keyName] = Form.createFormField({
                  value: props.getValueByFieldName(
                    keyName,
                    props.isEditable
                      ? monetizationTemplate[key].value
                      : monetizationTemplate[key]
                  ),
                });
              }
            });
          }
        }
        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            ),
          });
        }
      });
    // console.log(obj)
    return obj;
  },
  onValuesChange(props, values) {},
})(TemplateCardInfo);

export default TemplateInfoData;
